import { defineComponent } from 'vue'
import { BlockModule } from '../common'
import AnnouncementDialog from '@/components/website/announcement/AnnouncementDialog.vue'

new BlockModule({
    selector: '.msig-popup-announcement',
    vueComponent: defineComponent({
        name: 'msig-popup-announcement',
        components: { 
            AnnouncementDialog 
        },

        setup(props) {
        },
    }),
})
